export const getters = {
    loadingMenu: state => state.loadingMenu,
    errorMenu: state => state.errorMenu,
    menu: state => state.menu
}